import { type BasePageParams } from '@/app/urls/url-mapping';
import { type UrlEntry, type UrlRegion } from '@/types';

export const isIndexable = false;

export type IframeEmbedParams = { urlSegments: string[] } & BasePageParams;

const PREFIXES = ['master'] as const;

type Prefix = (typeof PREFIXES)[number];

export type IframePages = `iframeEmbed/${Prefix}`;

export const urls: Record<
  IframePages,
  Partial<Record<UrlRegion, UrlEntry<Prefix>>>
> = {
  'iframeEmbed/master': {
    de: 'master',
    'de-en': 'master',
    es: 'master',
    'es-en': 'master',
    fr: 'master',
    'fr-en': 'master',
    gb: 'master',
    nl: 'master',
    'nl-en': 'master',
    pt: 'master',
    'pt-en': 'master',
    us: 'master',
    ww: 'master',
  },
};

export const getIframePageType = (params: IframeEmbedParams): IframePages => {
  const {
    urlSegments: [prefix],
  } = params;
  return `iframeEmbed/${prefix}` as IframePages;
};

export const isIframePrefix = (segment: string): segment is Prefix =>
  PREFIXES.includes(segment as Prefix);
